import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/stock-block-kinds.js';
import form from '../forms/stock-block-kinds.js';
import * as types from '../types.js';

const stockBlockKinds = function ()
{
	const sbk_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(e => notify(e)));
		},
		async queryData(query)
		{
			return await api.call(api.list_stock_block_kinds, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_stock_block_kind, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			if (!old_data)
			{
				notify('Não é permitido criar código novo. Peça inclusão ao SIAL.', 'Naturezas de bloqueio');
				return undefined;
			}
			const _record = {
				label: String(data.label || '').trim(),
				is_disabled: data.is_disabled == '1' || data.is_disabled === true,
				sort_order: data.sort_order === '' || data.sort_order == null ? undefined : Number(data.sort_order),
			};
			return await api.call(api.update_stock_block_kind, data.company_id, data.code, _record);
		},
	});

	const fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'code', label: 'Código', types: [], placeholder: '', title: 'Código' },
		{ index: 3, field: 'label', label: 'Rótulo', types: [], placeholder: '', title: 'Rótulo' },
		{ index: 4, field: 'sort_order', label: 'Ordem', types: [], placeholder: '', title: 'Ordem' },
		{ index: 5, field: 'is_disabled', label: 'Inativo', types: [types.opt_bool()], placeholder: '', title: 'Inativo' },
	];

	sbk_crud.run(
		'stock_block_kinds',
		'Naturezas&nbsp;de&nbsp;Bloqueio',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		[]
	);
};

export default stockBlockKinds;
